import React from "react"
import { useTranslation } from "react-i18next"
import { Button, IconButton, SvgIcon } from "@mui/material"
import { ReactComponent as SeeQuoteIcon } from "../icons/icon_quote.svg"

interface Props {
  onClick: () => void
  stillQuoting: boolean
  iconOnly?: boolean
}

const SeeQuoteButton = ({ onClick, stillQuoting, iconOnly }: Props) => {
  const { t } = useTranslation("common")

  if (iconOnly) {
    return (
      <IconButton onClick={onClick} color="lightGold" sx={{ p: 1 }}>
        <SvgIcon component={SeeQuoteIcon} inheritViewBox style={{ fontSize: "1.125rem" }} />
      </IconButton>
    )
  }
  return (
    <Button
      variant="contained"
      color="lightGold"
      onClick={onClick}
      disabled={stillQuoting}
      endIcon={<SvgIcon component={SeeQuoteIcon} inheritViewBox />}
    >
      {stillQuoting ? t("quote.stillQuoting") : t("quote.seeQuote")}
    </Button>
  )
}

export default SeeQuoteButton
